/* lib/api/draftEntities.js — клиент inline-черновиков чата (порт из frontend/src/lib/api/draftEntities.js, 1:1).
 * Эндпойнты без LLM/квоты (recompute/commit черновика сущности). {ok,status,data}, не бросает. */
import { apiFetch } from './client.js';

// chat-entities (inline-черновики). Эндпойнты без LLM/квоты:
// - recompute: пересчёт производных чисел черновика БЕЗ записи в БД (только ТТК).
//   Возвращает {computed, warnings}; computed=null для card/menu.
// - commit: создать реальную сущность из (отредактированного) payload.
//   Возвращает {committed, kind, id, title, editor_route} либо
//   {error:'duplicate'|'invalid', code, detail} (400).

// F41: edited — что правил пользователь ('output' → состав масштабируется под
// выход; иначе выход := Σ выходов строк). Бэк возвращает нормализованный payload.
export const recomputeDraft = (kind, payload, edited) =>
  apiFetch('/api/chats/draft/recompute/', {
    method: 'POST',
    body: { kind, payload, edited: edited || null },
  });

export const commitDraft = ({ messageId, proposalId, kind, payload, chatId }) =>
  apiFetch('/api/chats/draft/commit/', {
    method: 'POST',
    body: {
      message_id: messageId ?? null,
      proposal_id: proposalId ?? null,
      kind,
      payload,
      // F37: привязать запускаемую джобу генерации рецептов меню к диалогу.
      chat_id: chatId ?? null,
    },
  });
